var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"confirm-account-access-modal"},[_c('ConfirmAccountAccess',_vm._b({},'ConfirmAccountAccess',_vm.$attrs,false)),_c('TabBar',{attrs:{"slot":"footer"},slot:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }